import { Grid, withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { withSnackbar } from "notistack";
import React from "react";
import {
  getShipperErrorInfo,
  getPickupDateTimeErrorInfo,
  getTerminalFieldError,
  getSearchFieldError,
  getShipperPickupWindow,
  getlatestReadyCloseTime,
} from "./ShipperInfo/utils";
import {
  getShipmentErrorInfo,
  checkAtLeastOneShipmentInvalid,
} from "./ShipmentInfo/utils";
import { getEditReasonErrorInfo } from "./EditReasonInfo/utils";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { postData } from "../../../../../../api/componentAPIs";
import appConstants from "../../../../../../appConstants";
import { AppLoading } from "../../../../../../loaders/loaders";
import Events from "../../../../../../utilities/EventEmitter";
import { trackEvent } from "../../../../../common/AppInsightsEventTracking";
import SwitchWithLabel from "../../DriverPopUp/common/CustomSwitch";
import BillingForm from "./Billing";
import PanelAction from "./components/Action";
import Error from "./components/Error";
import WithModal from "./components/WithModal";
import { PICKUP_MANAGEMENT_CONFIG } from "./config";
import {
  PICKUP_MANAGEMENT_MODES,
  WARNING_DETAILS,
  ORDERERD_FIELD_LIST,
} from "./constants";
import ShipmentInfoForm from "./ShipmentInfo";
import ShipperInfoForm from "./ShipperInfo";
import PickupInfo from "./ShipperInfo/PickupInfo";
import {
  getConfirmationButtonLabel,
  getDefaultPickupManagementErrorInfo,
  getDefaultPickupManagementInfo,
  getSavePickupMessage,
  checkIsDateTimeUpdated,
  getSelectedTerminalDetails,
  isVoidPickupMode,
  isMergePickupMode,
  getFormattedShippers,
  getFormattedTerminals,
  fetchTerminalAndRestrictionsData,
  getCombinedSpecialInstructions,
  getFirstSelectedAssignedDriverPickup,
  getShipperByPickupId,
} from "./utils";
import EditReasonForm from "./EditReasonInfo";
import VoidPickup from "./VoidPickupInfo";
import { getDefaultVoidPickData, getErrorInfo } from "./VoidPickupInfo/utils";
import Warning from "./components/Warning";
import SelectShipperForm from "./MergePickupShipperDetails"
import DriverDetails from "./MergePickupShipperDetails/DriverDetails"
import { isEqual } from "lodash/lang";
import { withFeatureFlags } from "../../../../../../userProfile/featureFlagsContext";
const styles = () => ({
  dialogMainContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
  },
  contentContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    paddingTop: 16,
    height: "100%"
  },
  leftPanelContainer: {
    marginTop: 8
  },
  rightPanelContainer: {
    paddingRight: 24
  },
  actionContainer:{
    display: "flex",
    flexDirection: "row",
    padding: "8px 24px 24px 24px",
    flex: 1,
    justifyContent: "flex-end"
  }
});

@inject("DispatchStore")
@observer
class PickupManagementForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isDateTimeUpdated: false,
      terminals: [],
      selectedTerminal: null,
      selectedTerminalError: null,
      selectedTerminalOffset: null,
      searchFieldError: null,
      pickupInfo: null,
      pickupErrorInfo: getDefaultPickupManagementErrorInfo(),
      voidPickup: getDefaultVoidPickData(),
      error: null,
      hasWarning: false,
      overrideWarning: false,
      isShipperSearched : false,
      selectedShipper : "",
      shipperList : [],
      selectedDriver : null,
      driverRoute : null,
    };
    this.pickupRestrictionsData = [];
    this.pickupRestrictedTerminals = [];
    this.isMiscellaneousAccountCode = false;
    this.warning = null;
    this.timer = null;
    this.enablePickupEdit = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupEdit
    );
    this.enableMergePickup = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableMergePickup
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !isVoidPickupMode(this.props.mode) &&
      (prevState.selectedTerminal !== this.state.selectedTerminal ||
        prevState.pickupInfo?.shipperInfo !==
          this.state.pickupInfo?.shipperInfo ||
        prevState.pickupInfo?.shipmentInfo !==
          this.state.pickupInfo?.shipmentInfo)
    ) {
      this.pickupRestrictionsValidation();
    }
    if (
      isMergePickupMode(this.props.mode) &&
      this.state.selectedShipper &&
      !isEqual(
        this.props.pickupData,
        prevProps.pickupData
      )
    ) {
      this.refreshShipperList();
    }
  }

  refreshShipperList = () => {
    const { pickupData, selectedPossibleMergePickupId } = this.props;
    const selectedShipper = JSON.parse(this.state.selectedShipper);
    const isNoLongerDuplicatePickup = pickupData.find(
      (pickup) =>
        pickup.pickupId?.toLowerCase() !==
        selectedShipper.pickupId.toLowerCase()
    );
    const shipperList = getFormattedShippers(pickupData, selectedPossibleMergePickupId);
    if (isNoLongerDuplicatePickup) {
      const firstAssignPickupSelected =
        getFirstSelectedAssignedDriverPickup(pickupData);
      const selectedPickupData = this.getMergePickupInitialData(
        firstAssignPickupSelected ?? pickupData[0],
        pickupData
      );
      this.setState({
        pickupInfo: getDefaultPickupManagementInfo(
          selectedPickupData,
          this.state.selectedTerminalOffset
        ),
        shipperList,
        selectedShipper: getShipperByPickupId(shipperList, selectedPickupData.pickupId),
        selectedDriver: firstAssignPickupSelected?.driverId,
      });
      this.updateIsMiscShipper(
        selectedPickupData?.shipperAccountNumber,
        selectedPickupData?.isMiscellaneousShipper
      );
    } else {
      this.setState({ shipperList });
    }
  };

  componentDidMount() {
    const {
      mode,
      pickupData,
      userData,
      DispatchStore,
      selectedPossibleMergePickupId,
    } = this.props;
    if (isVoidPickupMode(mode)) {
      this.initializeVoidPickupData();
    } else {
      this.loadPickupMgmntStaticData().then(
        ({terminals, pickupRestrictions}) => {
          let terminalsData = terminals;
          if (isMergePickupMode(mode) || this.isEditMode()) {
            terminalsData = terminals.filter((terminal) => {
              return [ userData.userProfile.terminal.code,...DispatchStore.movePickupTerminalList].includes(
                terminal.terminalCode
              );
            });
          }
          let shipperList = [],
            selectedPickupData,selectedDriver=null;
          if (isMergePickupMode(mode)) {
            const firstAssignPickupSelected = getFirstSelectedAssignedDriverPickup(pickupData);
            selectedPickupData = this.getMergePickupInitialData(
              firstAssignPickupSelected ?? pickupData[0],
              pickupData
            );
            shipperList = getFormattedShippers(pickupData, selectedPossibleMergePickupId);
            selectedDriver = firstAssignPickupSelected?.driverId
          } else {
            selectedPickupData = pickupData;
          }
          this.initializeCommonPickupMgmntData({
            selectedPickupData,
            shipperList,
            pickupRestrictions,
            terminalsData,
            selectedDriver
          });
        }
      );
    }
    Events.on("VoidPickup", this.checkVoidPickupStatus);
    Events.on("MergePickups", this.checkMergePickupStatus);
    trackEvent("Pickup_Management", this.props.userProfile, {
      event: "Viewed",
    });
  }

  componentWillUnmount() {
    Events.removeListener("VoidPickup", this.checkVoidPickupStatus);
    Events.removeListener("MergePickups", this.checkMergePickupStatus);
  }

  loadPickupMgmntStaticData = () => {
    const { DispatchStore, userData } = this.props;
    if(DispatchStore.terminals.length && DispatchStore.pickupRestrictions){
      return Promise.resolve({
        terminals : DispatchStore.terminals.slice(),
        pickupRestrictions : DispatchStore.pickupRestrictions.data
      });
    }
    return fetchTerminalAndRestrictionsData(
      userData.userProfile.terminal.code
    ).then(([terminalListRes, pickupRestrictionsRes]) => {
      DispatchStore.setTerminals(terminalListRes.data);
      DispatchStore.setPickupRestrictions({ data: pickupRestrictionsRes.data });
      return {
        terminals: terminalListRes.data ?? [],
        pickupRestrictions: pickupRestrictionsRes.data ?? [],
      };
    });
  }

  initializeVoidPickupData = () => {
    const { userData, pickupData } = this.props;
    this.setState({
      pickupInfo: getDefaultPickupManagementInfo(
        pickupData,
        userData.userProfile.terminal.offset
      ),
      selectedTerminal: userData.userProfile.terminal.code,
      selectedTerminalOffset: userData.userProfile.terminal.offset,
    });
    this.updateIsMiscShipper(
      pickupData.shipperAccountNumber,
      pickupData.isMiscellaneousShipper
    )
  }

  initializeCommonPickupMgmntData = ({
    selectedPickupData,
    shipperList,
    pickupRestrictions,
    terminalsData,
    selectedDriver
  }) => {
    const terminals = getFormattedTerminals(terminalsData);
    const selectedTerminal = getSelectedTerminalDetails(
      selectedPickupData?.terminalCode ?? this.props.userData.userProfile.terminal.code,
      terminals
    );
    this.pickupRestrictionsData = pickupRestrictions;
    this.pickupRestrictedTerminals = this.pickupRestrictionsData.map(
      (eachObj) => eachObj.terminalCode
    );
    this.setState({
      terminals,
      pickupInfo: getDefaultPickupManagementInfo(
        selectedPickupData,
        selectedTerminal.offset
      ),
      selectedTerminal: selectedTerminal.value,
      selectedTerminalOffset: selectedTerminal.offset,
      shipperList,
      selectedShipper: getShipperByPickupId(shipperList, selectedPickupData?.pickupId),
      selectedDriver
    });
    this.updateIsMiscShipper(
      selectedPickupData?.shipperAccountNumber,
      selectedPickupData?.isMiscellaneousShipper
    );
  }

  getMergePickupInitialData = (selectedPickup,selectedPickupsList) => {   
    const combinedSpecialInstructions = getCombinedSpecialInstructions(
      selectedPickupsList.map((pickup) => pickup.specialInstructions)
    );
    return {
      ...selectedPickup,
      ...getlatestReadyCloseTime(selectedPickupsList),
      specialInstructions : combinedSpecialInstructions,
      shipments : selectedPickupsList.map(pickup=>pickup.shipments).flat()
    }
  }

  getTerminalInputRef = (terminalRef) => {
    this.terminalRef = terminalRef;
  }

  getInitialPickupZipCodes = () => {
    return (
      this.props.pickupData?.shipments?.map(
        (shipment) => shipment.consigneeZip ?? ""
      ).filter(Boolean) ?? []
    );
  }


  updateIsMiscShipper = (shipperAccountNumber, isMiscellaneousShipper) => {
    this.isMiscellaneousAccountCode =
      !Boolean(shipperAccountNumber) || isMiscellaneousShipper;
  };

  checkVoidPickupStatus = (data) => {
    const { success, message, pickupId } = data;
    if (
      this.props.pickupData.pickupId.toUpperCase() !== pickupId?.toUpperCase()
    ) {
      return;
    }
    if (success) {
      this.props.enqueueSnackbar("Void Pickup Successful.", {
        variant: "success",
      });
      this.props.handleClose();
    } else {
      this.props.enqueueSnackbar(`Void Pickup Failed`, {
        variant: "error",
      });
      this.setState((prevState) => ({
        ...prevState,
        isLoading: false,
        error: message.error,
      }));
    }
    clearTimeout(this.timer);
  };

  checkMergePickupStatus = (data) => {
    const { success } = data;
    const { successMsg, errorMsg } = getSavePickupMessage(this.props.mode);
    if (success) {
      this.props.enqueueSnackbar(successMsg, {
        variant: "success",
      });
      this.props.handleClose();
    } else {
      this.props.enqueueSnackbar(errorMsg, {
        variant: "error",
      });
      this.setState({
        isLoading: false,
      });
    }
    clearTimeout(this.timer);
  };

  handleTerminalChange = (selectedTerminal) => {
    const selectedTerminalValue = selectedTerminal
      ? selectedTerminal.value
      : null;
    this.setState({
      selectedTerminal: selectedTerminalValue,
      selectedTerminalOffset: selectedTerminal ? selectedTerminal.offset : null,
      selectedTerminalError: getTerminalFieldError(selectedTerminalValue),
      searchFieldError: getSearchFieldError(selectedTerminalValue),
    });
  };

  updateFormData = (name, formData, formErrorData) => {
    this.setState(
      (prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          [name]: formData,
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          [name]: formErrorData,
        },
      }),
      () => {
        if (name === "pickupDateTimeInfo" && this.isEditMode()) {
          this.setState({
            isDateTimeUpdated: checkIsDateTimeUpdated(
              this.props.pickupData,
              this.state.pickupInfo.pickupDateTimeInfo,
            ),
          });
        }
      },
    );
  };

  isEditMode = () => {
    return this.props.mode === PICKUP_MANAGEMENT_MODES.EDIT_PICKUP;
  };

  onGridReady = (gridApi) => {
    this.gridApi = gridApi;
  };

  isShipperDataValid = () => {
    const { shipperInfo, pickupDateTimeInfo } = this.state.pickupInfo;
    const shipperErrorInfo = getShipperErrorInfo(
      shipperInfo,
      pickupDateTimeInfo.readyTime,
    );
    const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
      pickupDateTimeInfo,
      readyTime: pickupDateTimeInfo.readyTime,
      terminalOffset: this.state.selectedTerminalOffset,
      mode: this.props.mode,
    });
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipperInfo: shipperErrorInfo,
        pickupDateTimeInfo: pickupDateTimeErrorInfo,
      },
    }));
    const shipperError = Object.values({
      ...shipperErrorInfo,
      ...pickupDateTimeErrorInfo,
    }).filter((value) => value).length;
    return Boolean(!shipperError);
  };

  isShipmentDataValid = () => {
    const { shipmentInfo } = this.state.pickupInfo;
    const shipmentErrorInfoList = getShipmentErrorInfo(
      shipmentInfo,
      this.props.mode
    );
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipmentInfo: shipmentErrorInfoList,
      },
    }));
    const shipmentError = shipmentErrorInfoList.some((errorInfo) =>
      checkAtLeastOneShipmentInvalid(errorInfo),
    );
    if (shipmentError) {
      this.gridApi.isDataUpdatedOnGrid = true;
      this.gridApi.refreshCells();
    }
    return Boolean(!shipmentError);
  };

  isEditReasonDataValid = () => {
    const { editReasonInfo } = this.state.pickupInfo;
    const editReasonErrorInfo = getEditReasonErrorInfo(
      editReasonInfo,
      this.state.isDateTimeUpdated,
    );
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        editReasonInfo: editReasonErrorInfo,
      },
    }));
    const editReasonError = Object.values({
      ...editReasonErrorInfo,
    }).filter((value) => value).length;
    return Boolean(!editReasonError);
  };

  isZipCodeInPickupRestrictionZipList = (zipCode, terminalCode) => {
    return (
      this.pickupRestrictionsData
        .find((zipObj) => zipObj.terminalCode === terminalCode)
        ?.zips.includes(zipCode) ?? false
    );
  };


  isShipperRestrictedZipCode = () => {
    return this.isZipCodeInPickupRestrictionZipList(
      this.state.pickupInfo.shipperInfo.shipperZip,
      this.state.selectedTerminal,
    );
  };

  isTerminalInPickupRestrictedList = (terminalCode) => {
    return this.pickupRestrictedTerminals.includes(terminalCode);
  };

  getRestrictedTerminalForShipper = () => {
    return this.isTerminalInPickupRestrictedList(this.state.selectedTerminal)
      ? this.state.selectedTerminal
      : "";
  };

  getRestrictedTerminalsForShipment = () => {
    const restrictedDestinationTerminalList = [];
    const initialShipmentZipcodes = this.getInitialPickupZipCodes();
    this.state.pickupInfo.shipmentInfo.forEach((shipment) => {
      if (
        !initialShipmentZipcodes.includes(shipment.destinationZip) && // if shipment zipcodes do not belong to zipcodes used while creating the pickup
        this.isZipCodeInPickupRestrictionZipList(
          shipment.destinationZip,
          shipment.destinationTerminal
        )
      ) {
        restrictedDestinationTerminalList.push(shipment.destinationTerminal);
      }
       
    });
    return [...new Set(restrictedDestinationTerminalList)];
  };

  validateShipperWarning = () => {
    const matchedRestrictedTerminal = this.getRestrictedTerminalForShipper();
    if (
      matchedRestrictedTerminal &&
      this.isMiscellaneousAccountCode &&
      this.isShipperRestrictedZipCode()
    ) {
      return {
        hasWarning: true,
        label: `${matchedRestrictedTerminal} ${WARNING_DETAILS.SHIPPER_LABEL}`,
        description: WARNING_DETAILS.SHIPPER_DESCRIPTION,
      };
    }
    return { hasWarning: false };
  };

  validateShipmentWarning = () => {
    const matchedRestrictedZipCodeTerminals = this.getRestrictedTerminalsForShipment();
    if (matchedRestrictedZipCodeTerminals.length > 0) {
      return {
        hasWarning: true,
        label: `${matchedRestrictedZipCodeTerminals.join(", ")} ${
          WARNING_DETAILS.DESTINATION_LABEL
        }`,
        description: WARNING_DETAILS.DESTINATION_DESCRIPTION,
      };
    }
    return { hasWarning: false };
  };

  setWarningDetails = (warningDetails) => {
    const { label, description, hasWarning } = warningDetails;
    this.warning = {
      label,
      description,
    };
    this.setState({ hasWarning });
  };

  pickupRestrictionsValidation = () => {
    const shipperWarningDetails = this.validateShipperWarning();
    if (shipperWarningDetails.hasWarning) {
      this.setWarningDetails(shipperWarningDetails);
      return;
    }
    const shipmentWarningDetails = this.validateShipmentWarning();
    if (shipmentWarningDetails.hasWarning) {
      this.setWarningDetails(shipmentWarningDetails);
      return;
    }
    this.setWarningDetails({
      hasWarning: false,
      label: "",
      description: "",
    });
  };

  handleSubmit = () => {
    const {
      pickupInfo,
      selectedTerminal,
      isDateTimeUpdated,
      hasWarning,
      overrideWarning,
      selectedDriver
    } = this.state;
    const { pickupId, pickupNumber } = this.props.pickupData ?? {};
    const isShipperDataValid = this.isShipperDataValid();
    const isShipmentDataValid = this.isShipmentDataValid();
    const isEditReasonDataValid = isDateTimeUpdated
      ? this.isEditReasonDataValid()
      : true;
    if (
      isShipperDataValid &&
      isShipmentDataValid &&
      isEditReasonDataValid &&
      selectedTerminal &&
      !(hasWarning && !overrideWarning) //processing shipment will not be allowed if there is warning and not overridden
    ) {
      const selectedPickups = isMergePickupMode(this.props.mode) ? this.props.pickupData : null;
      
      const requestParams = PICKUP_MANAGEMENT_CONFIG[
        this.props.mode
      ].getRequestParams(
        {
          pickupData: {
            pickupInfo: pickupInfo,
            pickupTerminal: selectedTerminal,
            userProfile: this.props.userData.userProfile,
            pickupId,
            pickupNumber,
            isDateTimeUpdated,
          },
        selectedPickups,
        selectedDriver
        }
      );
      const apiName = PICKUP_MANAGEMENT_CONFIG[this.props.mode].apiName;
      isMergePickupMode(this.props.mode)
        ? this.mergePickups(apiName, requestParams)
        : this.savePickupData(apiName, requestParams);
    } else {
      this.setState(
        { 
          error: null,
        },
        () => setTimeout(this.focusOnFirstInputWithError)
      );
    }
  };

  focusOnFirstInputWithError = () => {
    const {
      selectedTerminalError,
      pickupErrorInfo: { shipperInfo, pickupDateTimeInfo, editReasonInfo },
    } = this.state;
    if (selectedTerminalError) {
      return this.terminalRef?.current?.focus();
    }
    const errorInfo = {
      ...shipperInfo,
      ...pickupDateTimeInfo,
      ...editReasonInfo,
    };
    const fieldToFocus = this.getFirstInputWithError(
      ORDERERD_FIELD_LIST,
      errorInfo
    );
    if (fieldToFocus === "editReasonCode") {
      return document.getElementById("editReasonInfo")?.scrollIntoView();
    }
    this.focusOnFieldById(fieldToFocus);
  }

  getFirstInputWithError = (orderedFieldList,errorInfo) => {
    return orderedFieldList.find(field => errorInfo[field]);
  }

  focusOnFieldById = (fieldId) => {
    document.getElementById(fieldId)?.focus();    
  }

  savePickupData = (apiName, requestParams) => {
    this.setState({
      isLoading: true,
      error: null,
    });
    const { successMsg, errorMsg } = getSavePickupMessage(this.props.mode);
    postData(apiName, requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          Events.emit("RefreshPickupsData", true);
          this.props.enqueueSnackbar(successMsg, {
            variant: "success",
          });
          this.props.handleClose();
          this.setState({
            isLoading: false,
          });
        } else {
          const error = response?.response?.data?.error?.message;
          this.props.enqueueSnackbar(errorMsg, {
            variant: "error",
          });
          this.setState({
            isLoading: false,
            error,
          });
        }
      },
      (_error) => {
        this.props.enqueueSnackbar(errorMsg, {
          variant: "error",
        });
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  updateSpecialInstructions = ({
    specialInstructions,
    pickupDate,
    pickupWindow,
  }) => {
    const shipperDayOfWeekComments = getShipperPickupWindow(
      new Date(pickupDate),
      pickupWindow
    )?.additionalComment;
    const combinedSpecialInstructions = [
      specialInstructions,
      shipperDayOfWeekComments,
    ];
    this.setState((prevState) => ({
      pickupInfo: {
        ...prevState.pickupInfo,
        specialInstructions : getCombinedSpecialInstructions(combinedSpecialInstructions),
      },
    }));
  };

  updateSelectedShipperDataOnSearch = ({
    specialInstructions,
    shipperInfo,
    pickupDateTimeInfo,
    isMiscellaneousShipper,
    isShipperSearched,
  }) => {
    if (isMergePickupMode(this.props.mode) && !isShipperSearched) {
      this.handleShipperSelection(this.state.selectedShipper); //  if Searched Shipper is cleared select previously selectd shipper in radio selections in case of merge pickup flow.
      this.setState({ isShipperSearched });
      return;
    }
      const shipperErrorInfo = getShipperErrorInfo(
        shipperInfo,
        pickupDateTimeInfo.readyTime
      );
      const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
        pickupDateTimeInfo,
        readyTime: pickupDateTimeInfo.readyTime,
        terminalOffset: this.state.selectedTerminalOffset,
      });
    this.updateIsMiscShipper(
      shipperInfo.shipperAccountNumber,
      isMiscellaneousShipper,
    );
    this.setState(
      (prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          pickupDateTimeInfo,
          shipperInfo,
          isSwapPickup: false,
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          shipperInfo: shipperErrorInfo,
          pickupDateTimeInfo: pickupDateTimeErrorInfo,
        },
        isShipperSearched,
      }),
      () =>
        this.updateSpecialInstructions({
          specialInstructions,
          pickupDate: pickupDateTimeInfo.pickupDate,
          pickupWindow: shipperInfo.pickupWindow,
        })
    );
    this.updateIsMiscShipper(
      shipperInfo.shipperAccountNumber,
      isMiscellaneousShipper
    );
  };

  handlePickupSwapToggle = (value) => {
    this.updateFormData(
      "isSwapPickup",
      value,
      this.state.pickupErrorInfo.shipperInfo,
    );
  };

  handleKeyDown = (event) => {
    if (event?.keyCode === 37) {
      // keyCode: 37, leftArrow Key pressed (disable switch). keyCode: 39, rightArrow Key pressed (enable switch)
      this.handlePickupSwapToggle(false);
    } else if (event?.keyCode === 39) {
      this.handlePickupSwapToggle(true);
    }
  };

  handleVoidPickupSubmit = () => {
    const {
      voidPickup,
      voidPickup: { errorInfo },
    } = this.state;
    const { pickupId } = this.props.pickupData;
    const newErrorInfo = getErrorInfo(errorInfo, voidPickup);
    this.setState((prevState) => ({
      ...prevState,
      voidPickup: {
        ...prevState.voidPickup,
        errorInfo: newErrorInfo,
      },
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if(error){
      return this.focusOnFieldById("comment")
    }
    if (!error) {
      const { voidReason, comment } = voidPickup;
      const voidData = {
        pickupId,
        terminalCode: this.props.userData.userProfile.terminal.code,
        voidReason,
        comment,
      };
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: true,
          error: null,
        }),
        this.onPickupManagementProgressTimeOut,
      );
      trackEvent("Void_Pickup", this.props.userProfile, {
        event: "Void_Pickup",
        eventData: voidData,
      });
      this.submitData("VoidPickup", voidData);
    }
  };

  mergePickups = (apiName, requestParams) => {
    this.setState(
      {
        isLoading: true,
        error: null,
      },
      this.onPickupManagementProgressTimeOut
    );
    this.submitData(apiName, requestParams);
  }

  submitData = (apiName, requestParams) => {
    postData(apiName, requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2);
        else {
          this.handleError();
        }
      },
      (_error) => {
        this.handleError();
      }
    );
  }

  updateVoidPickup = (voidPickupData) => {
    this.setState({
      voidPickup: voidPickupData,
    });
  };

  onPickupManagementProgressTimeOut = () => {
    this.timer = setTimeout(() => {
      this.setState({ isLoading: false });
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  handleError = () => {
    const { errorMsg } = getSavePickupMessage(this.props.mode);
    this.props.enqueueSnackbar(errorMsg, {
      variant: "error",
    });
    clearTimeout(this.timer);
    this.setState({
      isLoading: false,
    });
  };

  onSubmitButtonClicked = () => {
    const { mode } = this.props;
    if (isVoidPickupMode(mode)) {
      return this.handleVoidPickupSubmit;
    } else {
      return this.handleSubmit;
    }
  };

  handleShipperSelection = (selectedShipperData) => {
    const selectedShipper = JSON.parse(selectedShipperData)
    const selectedPickupData = this.props.pickupData.find(
      (pickup) =>
        pickup.rmaxShipperCode === selectedShipper.rmaxShipperCode &&
        pickup.pickupId === selectedShipper.pickupId
    );
    const pickupInfo = getDefaultPickupManagementInfo(
      this.getMergePickupInitialData(selectedPickupData, this.props.pickupData)
    );
    const shipperErrorInfo = getShipperErrorInfo(
      pickupInfo.shipperInfo,
      pickupInfo.pickupDateTimeInfo.readyTime
    );
    const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
      pickupDateTimeInfo : pickupInfo.pickupDateTimeInfo,
      readyTime: pickupInfo.pickupDateTimeInfo.readyTime,
      terminalOffset: this.state.selectedTerminalOffset,
    });
    this.setState((prevState) => ({
      pickupInfo,
      selectedShipper: selectedShipperData,
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipperInfo: shipperErrorInfo,
        pickupDateTimeInfo: pickupDateTimeErrorInfo,
      },
    }));
    this.handleDriverChange({ value: selectedPickupData.driverId });
    this.updateIsMiscShipper(
      selectedPickupData.shipperAccountNumber,
      selectedPickupData.isMiscellaneousShipper
    );
  }

  onToggleWarningOverride = () => {
    this.setState((prevState) => ({
      ...prevState,
      overrideWarning: !prevState.overrideWarning,
    }));
  };

  handleDriverChange = (option) => {
    const driverId = option ? option.value : null;
    const routeList = this.props.DispatchStore.currentActiveRoutes.slice();
    const driverRoute = driverId
      ? routeList.find((route) => route.driverId === driverId)
      : null;
    this.setState({
      selectedDriver: driverId,
      driverRoute,
    });
  }

  render() {
    const { handleClose, classes, mode, pickupData } = this.props;
    const {
      terminals,
      selectedTerminal,
      pickupInfo,
      pickupErrorInfo,
      isDateTimeUpdated,
      error,
      selectedTerminalOffset,
      selectedTerminalError,
      searchFieldError,
      overrideWarning,
      hasWarning,
      shipperList,
      selectedShipper,
      isShipperSearched,
      selectedDriver,
      driverRoute
    } = this.state;
    const showBillingForm = [
      PICKUP_MANAGEMENT_MODES.CREATE_PICKUP,
      PICKUP_MANAGEMENT_MODES.EDIT_PICKUP,
      PICKUP_MANAGEMENT_MODES.VOID_PICKUP,
    ].includes(mode);
    const showEditReasonForm = this.isEditMode() && isDateTimeUpdated;
    const isDisabledEditShipper = (!this.enablePickupEdit && this.enableMergePickup) // added for smt to disable edit shipper info
    const showDriverDetails = isMergePickupMode(mode) && !isDisabledEditShipper;
    if (!pickupInfo) {
      return (
        <div id="appContainer">
          <AppLoading />
        </div>
      );
    }
    return (
      <div className={classes.dialogMainContainer} id="mainContainer">
        <div className={`${classes.contentContainer} customScroll`}>
          <Grid container>
            <Grid item xs={4} className={classes.leftPanelContainer}>
              <ShipperInfoForm
                shipperInfo={pickupInfo.shipperInfo}
                shipperErrorInfo={pickupErrorInfo.shipperInfo}
                specialInstructions={pickupInfo.specialInstructions}
                terminals={terminals}
                userProfile={this.props.userData.userProfile}
                selectedTerminal={selectedTerminal}
                selectedTerminalOffset={selectedTerminalOffset}
                handleTerminalChange={this.handleTerminalChange}
                getTerminalRef={this.getTerminalInputRef}
                updateFormData={this.updateFormData}
                updateSelectedShipperDataOnSearch={
                  this.updateSelectedShipperDataOnSearch
                }
                isShipperSearched={isShipperSearched}
                mode={mode}
                selectedTerminalError={selectedTerminalError}
                searchFieldError={searchFieldError}
                isReadOnly={isVoidPickupMode(mode) ||  isDisabledEditShipper}
              />
            </Grid>
            <Grid item xs={8} className={classes.rightPanelContainer}>
              <Grid item xs={5}>
                <SwitchWithLabel
                  rowLabel="Is Pickup a Trailer Swap"
                  onChange={this.handlePickupSwapToggle}
                  value={pickupInfo.isSwapPickup}
                  disabled={isVoidPickupMode(mode)}
                  handleKeyDown={this.handleKeyDown}
                />
              </Grid>
              {shipperList.length > 0 && (
                <Grid item xs={12}>
                  <SelectShipperForm
                    shipperList={shipperList}
                    selectedShipper={selectedShipper}
                    handleShipperSelection={this.handleShipperSelection}
                    isShipperSearched={isShipperSearched}
                  />
                </Grid>
              )}
              {showDriverDetails && (
                <Grid item xs={12}>
                  <DriverDetails
                    drivers={this.props.DispatchStore.dispatchedDriversList}
                    selectedDriver={selectedDriver}
                    handleDriverChange = {this.handleDriverChange}
                    driverRoute = {driverRoute}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <PickupInfo
                  mode={mode}
                  pickupErrorInfo={pickupErrorInfo.pickupDateTimeInfo}
                  pickupInfo={pickupInfo.pickupDateTimeInfo}
                  updateFormData={this.updateFormData}
                  userProfile={this.props.userData.userProfile}
                  selectedTerminalOffset={selectedTerminalOffset}
                  pickupData={pickupData}
                  shipperInfo={pickupInfo?.shipperInfo}
                  updateSpecialInstructions={this.updateSpecialInstructions}
                />
              </Grid>
              <Grid item xs={12}>
                <ShipmentInfoForm
                  shipmentInfo={{
                    shipments: pickupInfo.shipmentInfo,
                    shipmentsErrors: pickupErrorInfo.shipmentInfo,
                  }}
                  handleChange={this.updateFormData}
                  title="ShipmentsGrid"
                  onGridReady={this.onGridReady}
                  mode={mode}
                />
              </Grid>
              {showBillingForm && (
                <Grid item xs={12}>
                  <BillingForm
                    mode={mode}
                    billingInfo={pickupInfo.billingInfo}
                    updateFormData={this.updateFormData}
                  />
                </Grid>
              )}
              {showEditReasonForm && (
                <Grid item xs={12}>
                  <EditReasonForm
                    editReasonInfo={pickupInfo.editReasonInfo}
                    editReasonErrorInfo={pickupErrorInfo.editReasonInfo}
                    updateFormData={this.updateFormData}
                    isDateTimeUpdated={isDateTimeUpdated}
                  />
                </Grid>
              )}
              {mode === PICKUP_MANAGEMENT_MODES.VOID_PICKUP && (
                <Grid item xs={12}>
                  <VoidPickup
                    glEventHub={this.props.glEventHub}
                    pickupId={pickupData.pickupId}
                    handleClose={handleClose}
                    updateVoidPickup={this.updateVoidPickup}
                    voidPickupData={this.state.voidPickup}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </div>
        {error && <Error message={error} />}
        <Grid className={classes.actionContainer}>
          <Warning
            mode={mode}
            warning={this.warning ?? {}}
            hasWarning={hasWarning}
            overrideWarning={overrideWarning}
            onToggleWarningOverride={this.onToggleWarningOverride}
          />
          <PanelAction
            handleClose={handleClose}
            confirmButtonText={getConfirmationButtonLabel(mode,selectedDriver)}
            handleSubmit={this.onSubmitButtonClicked()}
            isLoading={this.state.isLoading}
            isDisabled={
              (hasWarning && !overrideWarning) ||
              (isMergePickupMode(mode) && shipperList.length < 2) /* min 2 shipper required for merge */
            }
          ></PanelAction>
        </Grid>
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar,
  WithModal,
  withFeatureFlags,
)(PickupManagementForm);
